const allClients = [
	'/clients/client12.webp',
	'/clients/client35.webp',
	'/clients/client2.webp',
	'/clients/client36.webp',
	'/clients/client37.webp',
	'/clients/client3.webp',
	'/clients/client4.webp',
	'/clients/client5.webp',
	'/clients/client7.webp',
	'/clients/client38.webp',
	'/clients/client20.webp',
	'/clients/client8.webp',
	'/clients/client9.webp',
	'/clients/client10.webp',
	'/clients/client6.webp',
	'/clients/client24.webp',
	'/clients/client29.webp',
	'/clients/client1.webp',
	'/clients/client17.webp',
	'/clients/client15.webp',
	'/clients/client13.webp',
	'/clients/client21.webp',
	'/clients/client25.webp',
	'/clients/client23.webp',
	'/clients/client16.webp',
	'/clients/client22.webp',
	'/clients/client11.webp',
	'/clients/client34.webp',
	'/clients/client30.webp',
	'/clients/client14.webp',
	'/clients/client19.webp',
	'/clients/client18.webp',
	'/clients/client26.webp',
	'/clients/client40.webp',
];

export default function Clients() {
	return (
		<div className='flex w-full flex-col justify-center gap-10 bg-white p-8'>
			<h2 className='section-title'>Satisfied Clients</h2>

			<div className='h-[20vh] overflow-hidden'>
				<ul className='client-marquee flex h-full w-max'>
					{[...allClients, ...allClients].map((client, index) => {
						const isCopy = index >= allClients.length;

						return (
							<li
								key={index}
								aria-hidden={isCopy || undefined}
								className='flex h-full w-[18vw] shrink-0 items-center justify-center px-2'>
								<img
									src={client}
									alt={isCopy ? '' : `Client logo ${index + 1}`}
									loading='lazy'
									decoding='async'
									className='h-full w-full object-contain'
								/>
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
}
